import { LoaderButton } from './loader-button';
import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from './ui/button';

export function ExternalLinkButton({
  href,
  children,
  ...props
}: Omit<React.ComponentProps<typeof LoaderButton>, 'isLoading'> & {
  href: string;
}) {
  const [clicked, setClicked] = useState(false);
  return (
    <Button {...props} onClick={() => setClicked(true)} asChild>
      <a href={href}>
        {clicked ? <Loader2 className="h-4 w-4 animate-spin" /> : children}
      </a>
    </Button>
  );
}
